import { MyContract } from '@skippay/core/@types/myContract';
import { MyProfile } from '@skippay/core/@types/myProfile';

import { accountPackage } from 'jarabot/utils';
import MyProfileRevolvingApplicationQuery from 'queries/MyProfileRevolvingApplicationQuery.graphql';

import { toActionFlags } from '../../masking';
import JarabotComplianceQuery from '../../queries/JarabotComplianceQuery.graphql';
import { Compliance } from '../../types';
import { DomainSource } from '../types';

type ProfileData = {
	myProfile?: {
		accountType?: MyProfile['accountType'];
		options?: MyProfile['options'];
	};
};

export const eligibilitySource: DomainSource<ProfileData> = {
	domains: ['eligibility', 'account'],
	query: MyProfileRevolvingApplicationQuery,
	toModel: (data) => {
		const profile = data.myProfile;
		if (!profile) return {};
		return {
			eligibility: {
				canApplyForRevolving: profile.options?.canApplyForRevolvingContract ?? undefined,
				canApplyForInstallments: profile.options?.canApplyForInstallments ?? undefined,
			},
			account: { package: accountPackage(profile.accountType) },
		};
	},
};

interface ComplianceData {
	myProfile?: {
		kyc?: MyProfile['kyc'];
		amlLegalReview?: MyProfile['amlLegalReview'];
		amlKycRevalidation?: MyProfile['amlKycRevalidation'];
		pepRequirements?: MyProfile['pepRequirements'];
	} | null;
	myContract?: { customerBlockingReasons?: MyContract['customerBlockingReasons'] } | null;
}

export const complianceSource: DomainSource<ComplianceData> = {
	domains: ['compliance'],
	query: JarabotComplianceQuery,
	toModel: (data) => {
		const profile = data.myProfile;
		if (!profile) return {};
		const compliance: Compliance = {
			actionsRequired: toActionFlags({
				kycIsOutdated: profile.kyc?.isOutdated ?? undefined,
				amlLegalReviewRequested: profile.amlLegalReview?.isRequested ?? undefined,
				amlLegalReviewOutdated: profile.amlLegalReview?.expiresAt
					? profile.amlLegalReview.expiresAt.slice(0, 10) < new Date().toISOString().slice(0, 10)
					: undefined,
				amlKycRevalidationState: profile.amlKycRevalidation?.state,
				pepAssetsOriginQuestionnaireRequired:
					profile.pepRequirements?.isAssetsOriginQuestionnaireRequired ?? undefined,
				pepBankIdRequired: profile.pepRequirements?.isBankIdRequired ?? undefined,
				customerBlockingReasons: data.myContract?.customerBlockingReasons ?? undefined,
			}),
		};
		return { compliance };
	},
};
